import { render, staticRenderFns } from "./repositoryDetailsModal.vue?vue&type=template&id=388299c4"
import script from "./repositoryDetailsModal.vue?vue&type=script&lang=js"
export * from "./repositoryDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./repositoryDetailsModal.vue?vue&type=style&index=0&id=388299c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports